<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" to="/select-a-broker">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('mannual_proof.text3')}} <span class="bgTitle">{{$t('mannual_proof.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12">
                <Form class="personalDetails" @submit="submit">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <float-label class="form-group">
                                <Field
                                  class="form-control"
                                  name="first name"
                                  :placeholder="$t('personal_info.text1')"
                                  v-model="form.fname"
                                  rules="required"
                                />
                                <ErrorMessage class="text-danger" name="first name" />
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <float-label class="form-group">
                                <Field
                                  class="form-control"
                                  name="last name"
                                  :placeholder="$t('personal_info.text2')"
                                  v-model="form.lname"
                                  rules="required"
                                />
                                <ErrorMessage class="text-danger" name="last name" />
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <float-label class="form-group" :class="[{'selected' : form.dob}]">
                                <!-- <Field
                                 type="date"
                                  class="form-control"
                                  name="dob"
                                  placeholder=""
                                  v-model="form.dob"
                                  rules="required"
                                /> -->
                                <Datepicker v-model="form.dob" autoApply :enableTimePicker="false" ref="datepicker" name="dob" placeholder=" " @update:modelValue="handleDate" @cleared="greaterthan68 = false" />
                                <label class="afterSelect selectDOB">{{$t('personal_info.text3')}}</label>
                                <span v-if="greaterthan68" class="text-danger">{{$t('personal_info.text4')}}</span>
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <float-label class="form-group">
                                 <Field
                                  class="form-control"
                                  name="residential address1"
                                  :placeholder="$t('personal_info.text5')"
                                  v-model="form.address1"
                                  rules="required"
                                />
                                <ErrorMessage class="text-danger" name="residential address1" />
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <float-label class="form-group">
                                <Field
                                  class="form-control"
                                  name="residential address2"
                                  :placeholder="$t('personal_info.text6')"
                                  v-model="form.address2"
                                />
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="countrySelect form-group position-relative filter-dropdown" :class="[{'selected' : form.country}]">
                                <a @click="selectButton = !selectButton" href="javascript:void(0)" class="selectButton d-flex align-items-center justify-content-between">
                                    <span class="d-flex align-items-center" v-if="form.country.id && form.country.name"><img class="me-2" :src="'/assets/images/country_flag/'+form.country.name.toLowerCase()+'.webp'" alt="Icon" title="Greece" loading="lazy" width="20" />{{form.country.name}}</span>
                                            <span v-else>&nbsp;</span>
                                    <vue-feather size="20" type="chevron-down"></vue-feather>
                                </a>
                                <label class="afterSelect">{{$t('personal_info.text7')}}</label>
                                <ul class="dropdown_menu_animated scrollable" :class="selectButton ? 'show' : ''" > 
                                    <li class="form-group mb-1">
                                        <input type="text" :placeholder="$t('personal_info.text8')" class="form-control radius-0" v-model="countrysearch" />
                                    </li>
                                    <li v-for="item,key in getCountries" :key="key">
                                        <a href="javascript:void(0)" class="d-flex align-items-center" @click="form.country = item;selectButton = false;countrysearch = ''" ><img class="me-2"
                                                :src="'/assets/images/country_flag/'+item.name.toLowerCase()+'.webp'" alt="Icon" :title="item.name" loading="lazy" width="20"/> {{item.name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <float-label class="form-group">
                                <Field
                                  class="form-control"
                                  name="city"
                                  :placeholder="$t('personal_info.text9')"
                                  v-model="form.city"
                                  rules="required"
                                />
                                <ErrorMessage class="text-danger" name="city" />
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <float-label class="form-group">
                                <Field
                                  class="form-control"
                                  name="postcode"
                                  :placeholder="$t('personal_info.text10')"
                                  v-model="form.postcode"
                                  rules="required"
                                />
                                <ErrorMessage class="text-danger" name="postcode" />
                            </float-label>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="countrySelect form-group position-relative filter-dropdown" :class="[{'selected' : form.taxResidence}]">
                                <a @click="selectButton2 = !selectButton2" href="javascript:void(0)"
                                    class="selectButton d-flex align-items-center justify-content-between"><span
                                        class="d-flex align-items-center" v-if="form.taxResidence.id && form.taxResidence.name"><img class="me-2" :src="'/assets/images/country_flag/'+form.taxResidence.name.toLowerCase()+'.webp'"
                                            :alt="$t('personal_info.text23')" :title="$t('personal_info.text23')" loading="lazy" width="20" />{{form.taxResidence.name}}</span>
                                            <span v-else>&nbsp;</span>
                                    <vue-feather size="20" type="chevron-down"></vue-feather>
                                </a>
                                <label class="afterSelect">{{$t('personal_info.text11')}}</label>
                                <ul class="dropdown_menu_animated scrollable" :class="selectButton2 ? 'show' : ''" > 
                                    <li class="form-group mb-1">
                                        <input type="text" :placeholder="$t('personal_info.text8')" class="form-control radius-0" v-model="taxResidenceSearch" />
                                    </li>
                                    <li v-for="item,key in getCountries" :key="key">
                                        <a href="javascript:void(0)" class="d-flex align-items-center" @click="form.taxResidence = item;selectButton2 = false;taxResidenceSearch = ''" ><img class="me-2"
                                                :src="'/assets/images/country_flag/'+item.name.toLowerCase()+'.webp'" :alt="$t('personal_info.text23')" :title="item.name" loading="lazy" width="20"/>
                                            {{item.name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="countrySelect form-group position-relative filter-dropdown" :class="[{'selected' : form.nationality}]">
                                <a @click="selectButton3 = !selectButton3" href="javascript:void(0)"
                                    class="selectButton d-flex align-items-center justify-content-between"><span
                                        class="d-flex align-items-center" v-if="form.nationality.id && form.nationality.name"><img class="me-2" :src="'/assets/images/country_flag/'+form.nationality.name.toLowerCase()+'.webp'"
                                            :alt="$t('personal_info.text23')" :title="$t('personal_info.text23')" loading="lazy" width="20" />{{form.nationality.name}}</span>
                                            <span v-else>&nbsp;</span>
                                    <vue-feather size="20" type="chevron-down"></vue-feather>
                                </a>
                                <label class="afterSelect">{{$t('personal_info.text12')}}</label>
                                <ul class="dropdown_menu_animated scrollable" :class="selectButton3 ? 'show' : ''" > 
                                    <li class="form-group mb-1">
                                        <input type="text" :placeholder="$t('personal_info.text8')" class="form-control radius-0" v-model="nationalitySearch" />
                                    </li>
                                    <li v-for="item,key in getCountries" :key="key">
                                        <a href="javascript:void(0)" class="d-flex align-items-center" @click="form.nationality = item;selectButton3 = false;nationalitySearch = ''" ><img class="me-2"
                                                :src="'/assets/images/country_flag/'+item.name.toLowerCase()+'.webp'" :alt="$t('personal_info.text23')" :title="item.name" loading="lazy" width="20"/>
                                            {{item.name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 my-2">
                            <p class="customAlert position-relative f-13"><i class="alertCircle fa fa-exclamation"
                                    aria-hidden="true"></i>{{$t('personal_info.text13')}}</p>
                        </div>
                        <div class="col-6 buttonElement mb-3">
                            <button type="submit" class="grd_btn d-flex align-items-center" :class="((!form.dob || !Object.keys(form.country).length || !Object.keys(form.nationality).length || !Object.keys(form.taxResidence).length)) ? 'disabled':''" :disabled="(!form.dob || !Object.keys(form.country).length || !Object.keys(form.nationality).length || !Object.keys(form.taxResidence).length) ? true : false"> {{$t('mannual_upload.text13')}}</button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </section>
    <div class="modal letterDir fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h3 class="mb-4">{{$t('personal_info.text14')}}</h3>
                    <p>{{$t('personal_info.text15')}}</p>
                    <h6>{{$t('personal_info.text16')}}</h6>
                    <p><strong class="d-block">{{$t('personal_info.text17')}}</strong>
                        {{$t('personal_info.text18')}}</p>
                    <p><strong class="d-block">{{$t('personal_info.text19')}}</strong>{{$t('personal_info.text20')}}</p>
                    <p>{{$t('personal_info.text21')}}</p>
                    <p>{{$t('personal_info.text22')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import { Form, Field, ErrorMessage } from "vee-validate";
import $ from 'jquery'
import moment from 'moment'
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            selectButton: false,
            selectButton2: false,
            selectButton3: false,
            selectNumber: false,
            brokers: false,
            selecServer: false,
            form:{
                fname : '',
                lname : '',
                dob :'',
                address1 : '',
                address2 : '',
                city : '',
                postcode : '',
                country : {},
                nationality : {},
                taxResidence : {}
            },
            countrysearch : '',
            nationalitySearch : '',
            taxResidenceSearch : '',
            greaterthan68 : ''
        }
    },
    computed: {
       getCountries(){
            if(Object.keys(this.store.countryList).length > 0){
                let data = Object.values(this.store.countryList);
                if(this.countrysearch){
                    return data.filter(item => item.name.toLowerCase().includes(this.countrysearch.toLowerCase()))
                }else if(this.nationalitySearch){
                    return data.filter(item => item.name.toLowerCase().includes(this.nationalitySearch.toLowerCase()))
                }else if(this.taxResidenceSearch){
                    return data.filter(item => item.name.toLowerCase().includes(this.taxResidenceSearch.toLowerCase()))
                }else{
                    return data
                }

            }else{
                return []
            }
        }
    },
    components: {
        FloatLabel,
        Form,
        Field,
        ErrorMessage,
    },
    methods:{
        handleDate(){
            if(this.form.dob){
                const dateA = moment();
                const dateB = moment(this.form.dob).format('YYYY-MM-DD'); 
                const age = dateA.diff(dateB, 'years');
                if(age < 18){
                    this.greaterthan68 = true
                }else{
                    this.greaterthan68 = false
                }
            }
        },
        submit(){
            if(!this.greaterthan68){
                this.store.$patch({brokerInfo : this.form})
                this.$router.replace({name : 'create_broker_account2',params:{'id':this.$route.params.id}})
            }

        },
        getCountryData(code){
            if(Object.keys(this.store.countryList).length && code){
                return Object.values(this.store.countryList).filter(val => val.isoCodeA3 == code)[0]

            }
        }
    },
    mounted(){
        if(Object.keys(this.store.customerDetail).length){
            this.form.fname = (this.store.customerDetail.firstName) ? this.store.customerDetail.firstName : ''
            this.form.lname = (this.store.customerDetail.lastName) ? this.store.customerDetail.lastName : ''
            this.form.country = (this.store.customerDetail.countryIsoCodeA3) ? this.getCountryData(this.store.customerDetail.countryIsoCodeA3) : ''
            this.form.nationality = (this.store.customerDetail.countryIsoCodeA3) ? this.getCountryData(this.store.customerDetail.countryIsoCodeA3) : ''
            this.form.taxResidence = (this.store.customerDetail.countryIsoCodeA3) ? this.getCountryData(this.store.customerDetail.countryIsoCodeA3) : ''
        }
        if(Object.keys(this.store.brokerInfo).length){
            this.form.dob = (this.store.brokerInfo.dob) ? this.store.brokerInfo.dob : ''
            this.form.address1 = (this.store.brokerInfo.address1) ? this.store.brokerInfo.address1 : ''
            this.form.address2 = (this.store.brokerInfo.address2) ? this.store.brokerInfo.address2 : ''
            this.form.city = (this.store.brokerInfo.city) ? this.store.brokerInfo.city : ''
            this.form.postcode = (this.store.brokerInfo.postcode) ? this.store.brokerInfo.postcode : ''
            this.form.postcode = (this.store.brokerInfo.postcode) ? this.store.brokerInfo.postcode : ''
            this.form.nationality = (this.store.brokerInfo.nationality && Object.keys(this.store.brokerInfo.nationality).length) ? this.store.brokerInfo.nationality : ''
            this.form.taxResidence = (this.store.brokerInfo.taxResidence && Object.keys(this.store.brokerInfo.taxResidence).length) ? this.store.brokerInfo.taxResidence : ''
        }
        const _that = this;
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".filter-dropdown").length) {
                _that.selectButton = false;
                _that.selectButton2 = false;
                _that.selectButton3 = false;
            }
        });
    },
}
</script>
<style>
    .disabled {
    pointer-events: none;
    opacity: 0.5;
    }
</style>